import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authApi } from '../api/auth'
import AuthShell from '../components/AuthShell'
import { inputCls, labelCls, primaryBtn } from '../components/form'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await authApi.forgotPassword(email)
      setSent(true)
    } catch {
      setError('요청을 처리하지 못했습니다. 잠시 후 다시 시도하세요.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthShell
      title="비밀번호 재설정"
      lead={sent ? undefined : '가입한 이메일 주소를 입력하면 재설정 링크를 보냅니다.'}
      footer={<Link to="/login" className="text-gray-500 hover:text-gray-900 transition-colors">로그인으로 돌아가기</Link>}>
      {sent ? (
        <div className="space-y-3">
          {/* 서버는 계정 존재 여부와 무관하게 항상 성공을 돌려준다 — 문구도 그 전제로 쓴다 */}
          <p className="text-sm text-gray-700 leading-relaxed">
            <span className="font-medium text-gray-900">{email}</span> 로 가입된 계정이 있으면
            비밀번호 재설정 링크를 보냈습니다. 링크는 1시간 동안 유효합니다.
          </p>
          <p className="text-sm text-gray-500">메일이 오지 않으면 스팸함을 확인하거나 잠시 후 다시 요청하세요.</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label htmlFor="fp-email" className={labelCls}>이메일</label>
            <input id="fp-email" type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)}
              required autoFocus className={inputCls} placeholder="name@company.com" />
          </div>
          {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
          <button type="submit" disabled={loading} className={`w-full ${primaryBtn} py-2.5`}>
            {loading ? '보내는 중…' : '재설정 링크 보내기'}
          </button>
        </form>
      )}
    </AuthShell>
  )
}
